import React from 'react'
import { Form } from 'antd'
import Editor from '../../../../../../../../components/common/Editor/Editor'
import { LANGUAGES } from '../../../../../../../../constants/languages'
import { useSelector } from 'react-redux'
import { useAssignmentAccess } from '../../../../../../components/access/Access'
import { Perm, State } from '../../../../../../../../constants/assignment-permissions'

const TestTestSuite = () => {
    const language = useSelector(state => state.assignment.assignment.language)
    const { hasAccess: hasEditingPermission } = useAssignmentAccess([Perm.CAN_EDIT, State.NOT_PROCESSING, State.NOT_MBA, State.UNPUBLISHED])

    const validateTestSuite = (rule, value) => {
        if (language !== LANGUAGES.JAVA.value || !value) return Promise.resolve()

        // Regex to match @Test methods and check if they're public
        const testMethodRegex = /@Test\s+([\w\s]+)?\s*(void|[\w<>]+)\s+(\w+)\s*\(/g
        const matches = value.match(testMethodRegex)

        if (matches) {
            const nonPublicTests = matches.filter(method => !method.includes('public'))
            if (nonPublicTests.length > 0) {
                return Promise.reject(
                    new Error(
                        'All @Test methods must be declared public. Please update the visibility of non-public tests.',
                    ),
                )
            }
        }
        return Promise.resolve()
    }

    return (
        <Form.Item
            name='testSuite'
            rules={[
                {
                    required: true,
                    message: 'Test Suite is required',
                },
                { validator: validateTestSuite },
            ]}
        >
            <Editor
                language={language === LANGUAGES.SQL.value ? LANGUAGES.PYTHON.value : language}
                title={<label>Test Suite</label>}
                readOnly={!hasEditingPermission}
            />
        </Form.Item>
    )
}

export default TestTestSuite 